import { JobOpeningIcon } from "../assets/svg/JobOpening";
import { DescriptionIcon } from "../assets/svg/DescriptionIcon";

export const bgVtableData =[
    {    id: 1,
        empId: "100",
        empName: "Ram",
        doj: "03-02-2025",
        createAt: "31-03-2025",
        sharedAt: "01-04-2025",
        sharedTo: "02-04-2025",
        link: "link",
    },
    {   id: 2,
        empId: "101",
        empName: "Abhijit",
        doj: "16-02-2024",
        createAt: "31-03-2025",
        sharedAt: "01-04-2025",
        sharedTo: "02-04-2025",
        link: "link",
    },
    {  id: 3,
        empId: "102",
        empName: "Sagar",
        doj: "15-02-2024",
        createAt: "31-03-2025",
        sharedAt: "01-04-2025",
        sharedTo: "02-04-2025",
        link: "link",
    },
    {    id: 4,
        empId: "103",
        empName: "Om Datt",
        doj:     "15-01-2024",
        createAt: "31-03-2025",
        sharedAt: "01-04-2025",
        sharedTo: "02-04-2025",
        link: "link",
    },
]

export const bgVerificationTabsData = [
  { label: 'Candidate Information', Icon: JobOpeningIcon },
  { label: 'Comments by HR', Icon: DescriptionIcon },
];

export const   natureOfEmplment= ["Permanent","Contract","Internship"];
export const   location= ["Noida","Gurgaon","USA"];
export const   exitFormalitie= ["Yes","No"];